import _ from 'lodash'

// eslint-disable-next-line import/no-cycle
import { axiosDS } from '@pp/axios'
// eslint-disable-next-line import/no-cycle
import { requestContent, receiveContent } from './content'

// //////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
// //////////////////////////////////////////////////////////////////////////////////

export const INIT_EDIT = 'pp.admin/page/INIT_EDIT'
export const CONFIRM_EDIT = 'pp.admin/page/CONFIRM_EDIT'
export const CANCEL_EDIT = 'pp.admin/page/CANCEL_EDIT'

export const SET_KEY_TAB = 'pp.admin/page/SET_KEY_TAB'
export const INIT_CREATE = 'pp.admin/page/INIT_CREATE'
export const CONFIRM_CREATE = 'pp.admin/page/CONFIRM_CREATE'
export const CANCEL_CREATE = 'pp.admin/page/CANCEL_CREATE'

export const SET_ENTITY = 'pp.admin/page/SET_ENTITY'
export const SET_ENTITY_NAME = 'pp.admin/page/SET_ENTITY_NAME'
export const RECEIVE_ENTITY = 'pp.admin/page/RECEIVE_ENTITY'

export const CLEAR_ENTITY = 'pp.admin/page/CLEAR_ENTITY'
export const CLEAR_ENTITY_NAME = 'pp.admin/page/CLEAR_ENTITY_NAME'
export const CLEAR_PAGE = 'pp.admin/page/CLEAR_PAGE'

export const ADD_PARAM = 'pp.admin/page/ADD_PARAM'
export const ADD_PARAM_TO_ENTITY = 'pp.admin/page/ADD_PARAM_TO_ENTITY'
export const CLEAR_PARAMS = 'pp.admin/page/CLEAR_PARAMS'

export const SET_FILTER = 'pp.admin/page/SET_FILTER'
export const RESET_FILTER = 'pp.admin/page/RESET_FILTER'

export const MAKE_INVISIBLE = 'pp.admin/page/MAKE_INVISIBLE'
export const MAKE_VISIBLE = 'pp.admin/page/MAKE_VISIBLE'
export const CLEAR_INVISIBILITY = 'pp.admin/page/CLEAR_INVISIBILITY'
export const TOGGLE_INVISIBILITY = 'pp.admin/page/TOGGLE_INVISIBILITY'

export const SET = 'pp.admin/page/SET'
export const SET_BRANCH = 'pp.admin/page/SET_BRANCH'
export const UPDATE_BRANCH = 'pp.admin/page/UPDATE_BRANCH'
export const CLEAR_BRANCH = 'pp.admin/page/CLEAR_BRANCH'

// //////////////////////////////////////////////////////////////////////////////////
// ACTIONS
// //////////////////////////////////////////////////////////////////////////////////

export const initEdit = (payload) => ({ type: INIT_EDIT, payload })
export const confirmEdit = (payload) => ({ type: CONFIRM_EDIT, payload })
export const cancelEdit = (payload) => ({ type: CANCEL_EDIT, payload })

export const setKeyTab = (payload) => ({ type: SET_KEY_TAB, payload })
export const initCreate = (payload) => ({ type: INIT_CREATE, payload })
export const confirmCreate = (payload) => ({ type: CONFIRM_CREATE, payload })
export const cancelCreate = (payload) => ({ type: CANCEL_CREATE, payload })

export const setEntity = (payload) => ({ type: SET_ENTITY, payload })

export const setEntityName = (payload) => ({ type: SET_ENTITY_NAME, payload })
export const receiveEntity = (payload) => ({ type: RECEIVE_ENTITY, payload })

export const clearPage = () => ({ type: CLEAR_PAGE })
export const clearEntity = () => ({ type: CLEAR_ENTITY })
export const clearEntityName = () => ({ type: CLEAR_ENTITY_NAME })

export const addParam = (payload) => ({ type: ADD_PARAM, payload })
export const addParamToEntity = (payload) => ({ type: ADD_PARAM_TO_ENTITY, payload })
export const clearParams = () => ({ type: CLEAR_PARAMS })

export const setFilter = (payload) => ({ type: SET_FILTER, payload })
export const resetFilter = () => ({ type: RESET_FILTER })

export const makeVisible = (payload) => ({ type: MAKE_VISIBLE, payload })
export const makeInvisible = (payload) => ({ type: MAKE_INVISIBLE, payload })
export const clearInvisibility = (payload) => ({ type: CLEAR_INVISIBILITY, payload })
export const toggleInvisibility = (payload) => ({ type: TOGGLE_INVISIBILITY, payload })

export const set = (payload) => ({ type: SET, payload })
export const setBranch = (payload) => ({ type: SET_BRANCH, payload })
export const updateBranch = (payload) => ({ type: UPDATE_BRANCH, payload })
export const clearBranch = (payload) => ({ type: CLEAR_BRANCH, payload })

// //////////////////////////////////////////////////////////////////////////////////
// REDUCER
// //////////////////////////////////////////////////////////////////////////////////
const initialState = {
	entity: {},
	entityName: '',
	creating: false,
	editing: false,
	params: [],
	filter: {},
	invisibility: [],
}

export function fetchEntity(req) {
	return (dispatch) => {
		const params = { params: req.params } || {}
		dispatch(requestContent(req))
		return axiosDS()
			.get(req.url, params)
			.then((res) => {
				dispatch(receiveContent({ [req.key]: null }))
				dispatch(receiveEntity(res.data))
				if (req.callback) req.callback(res)
			})
			.catch((res) => {
				if (req.errorCallback) req.errorCallback(res)
				// eslint-disable-next-line no-throw-literal
				throw `Could not fetch ${req.url} (${res})`
			})
	}
}

export default function reducer(state = initialState, action) {
	const nextState = _.cloneDeep(state)
	let branch
	let data
	let currentBranchData
	let nextBranchData
	let entity
	let params
	let invisibility
	let invisibilityIndex

	switch (action.type) {
		case SET_BRANCH:
			return _.set(nextState, action.payload.branch, action.payload.data)

		case UPDATE_BRANCH:
			// eslint-disable-next-line prefer-destructuring
			branch = action.payload.branch
			// eslint-disable-next-line prefer-destructuring
			data = action.payload.data

			currentBranchData = { ..._.get(state, branch, {}) }
			nextBranchData = _.merge(currentBranchData, data)

			return { ...state, [branch]: nextBranchData }

		case RECEIVE_ENTITY:
			return { ...state, entity: action.payload }

		case SET_ENTITY:
			return { ...state, entity: action.payload }

		case SET_ENTITY_NAME:
			return { ...state, entityName: action.payload }

		case CLEAR_PAGE:
			return { ...state, ...initialState }

		case CLEAR_ENTITY:
			return { ...state, entity: {} }

		case CLEAR_ENTITY_NAME:
			return { ...state, entityName: '' }

		case SET_KEY_TAB:
			return { ...state, key_tab: action.payload }

		case INIT_CREATE:
			return { ...state, creating: true }

		case INIT_EDIT:
			return { ...state, editing: true }

		case CANCEL_CREATE:
			return { ...state, creating: false }

		case CANCEL_EDIT:
			return { ...state, editing: false }

		case SET_FILTER:
			return { ...state, filter: action.payload }
		case RESET_FILTER:
			return { ...state, filter: {} }

		case ADD_PARAM_TO_ENTITY:
			// eslint-disable-next-line prefer-destructuring
			entity = state.entity
			entity[action.payload.key] = action.payload.data
			return { ...state, entity }

		case ADD_PARAM:
			params = state.params.slice()
			params.push(action.payload)
			return { ...state, params }

		case CLEAR_PARAMS:
			return { ...state, params: [] }

		case MAKE_INVISIBLE:
			invisibility = state.invisibility.slice()
			if (invisibility.indexOf(action.payload) === -1) invisibility.push(action.payload)
			return { ...state, invisibility }

		case MAKE_VISIBLE:
			invisibility = state.invisibility.slice()
			invisibilityIndex = invisibility.indexOf(action.payload)
			if (invisibilityIndex !== -1) invisibility.splice(invisibilityIndex, 1)

			return { ...state, invisibility }

		case TOGGLE_INVISIBILITY:
			invisibility = state.invisibility.slice()

			invisibilityIndex = invisibility.indexOf(action.payload)
			if (invisibilityIndex !== -1) invisibility.splice(invisibilityIndex, 1)
			else invisibility.push(action.payload)

			return { ...state, invisibility }

		case CLEAR_INVISIBILITY:
			return { ...state, invisibility: initialState.invisibility }

		default:
			return state
	}
}
